import { ChevronLeftIcon, ChevronRightIcon } from '@repo/studio-design-system-ui-icons/arrows'
import { IconButton } from '@repo/studio-design-system-ui-button'
import type { ButtonSize, ButtonVariant } from '@repo/studio-design-system-ui-button'
import { tw } from 'utils/classnames'

export function ScrollButton({
  buttonHeight,
  variant,
  buttonVariant = 'secondary',
  buttonSize = 'md',
  onClick,
}: {
  variant: 'left' | 'right'
  buttonHeight: number
  buttonVariant?: ButtonVariant
  buttonSize?: ButtonSize
  onClick: () => void
}) {
  return (
    <div
      className={tw(
        'absolute top-0 w-24 flex items-center pointer-events-none',
        variant === 'left' && 'left-0 justify-start',
        variant === 'right' && 'right-0 justify-end',
      )}
      style={{ height: buttonHeight }}
    >
      <IconButton
        className="pointer-events-auto mx-4"
        size={buttonSize}
        variant={buttonVariant}
        onClick={onClick}
      >
        {variant === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </IconButton>
    </div>
  )
}
